export default __webpack_public_path__ + "static/media/nft-2.8f828ae7.gif";